import { VehicleVersion } from './vehicle-version.model';

export class VehicleVersionSelectOption {
    key: VehicleVersion;
    value: string;

    constructor(data?: VehicleVersionSelectOption) {
        if (data) {
            Object.assign(this, data);
        }
    }
}
